export function validateArray(arr, dim, validator, testType) {
    if (!Array.isArray(arr)) {
        return { success: false, error: 'Expected array, got non-array' };
    }
    for (const element of arr) {
        if (Array.isArray(element)) {
            if (dim > 1) {
                const result = validateArray(element, dim - 1, validator, testType);
                if (!result.success) {
                    return result;
                }
            }
            else {
                return { success: false, error: 'Array element is array when it should be ' + testType };
            }
        }
        else if (dim === 1) {
            if (validator !== undefined) {
                const result = validator.validate(element);
                if (!result.success) {
                    return result;
                }
            }
            else if (typeof element !== testType) {
                return { success: false, error: 'Array element is wrong type' };
            }
        }
        else {
            return { success: false, error: 'Array element is not array when it should be' };
        }
    }
    return { success: true };
}
export function validateDictionary(dictionary, depth, validator, testType) {
    if (typeof dictionary !== 'object') {
        return { success: false, error: 'Expected dictionary, got non-object' };
    }
    for (const key in dictionary) {
        if (depth > 1) {
            if (typeof dictionary[key] === 'object') {
                const result = validateDictionary(dictionary[key], depth - 1, validator, testType);
                if (!result.success) {
                    return result;
                }
            }
            else {
                return { success: false, error: 'Dictionary element is not dictionary when it should be' };
            }
        }
        else if (depth === 1) {
            if (validator !== undefined) {
                const result = validator.validate(dictionary[key]);
                if (!result.success) {
                    return result;
                }
            }
            else if (typeof dictionary[key] !== testType) {
                return { success: false, error: 'Dictionary element is wrong type' };
            }
        }
        else {
            return { success: false, error: 'Dictionary element is not dictionary when it should be' };
        }
    }
    return { success: true };
}
//# sourceMappingURL=validator-common.js.map